export class ProfessionalRegModel{
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    zip: string;
    state: string;
    mlsAffiliation: string;
    licenseNumber: string;
    licenseExpiration: string;
    licenseState: string;
    email: string;
    registrationCode: string;
    phone: string;
    companyName: string;
    companyUrl: string;
    password: string;
    type: number;
    paymentMethodNonce: string;
    MembershipPlan: string;
}